<app-filter-form
  [filters]="queryFilters"
  [entity]="'product-moves'"
  (onExportResult)="filter()"
  (onClearClick)="clearFilters()"
  (onSubmit)="filter()"
  [isFilterInvisible]="true"
  [areExportsInFilter]="true"
>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-3 col-xl-2">
      <form-row-input
        [label]="'date.from'"
        [icon]="null"
        [inputType]="'date'"
        [(model)]="filterFrom"
        (keydown.enter)="filter()"
      ></form-row-input>
    </div>
    <div class="col-12 col-sm-6 col-md-3 col-xl-2">
      <form-row-input
        [label]="'date.to'"
        [icon]="null"
        [inputType]="'date'"
        [(model)]="filterTo"
        (keydown.enter)="filter()"
      ></form-row-input>
    </div>
    <ng-container *ngIf="product.enabledBatchExpiration">
      <div class="col-12 col-sm-6 col-md-3 col-xl-2">
        <form-row-select
          [label]="'product.batch'"
          [(model)]="selectedBatch"
          [options]="batches"
          [icon]="null"
        ></form-row-select>
      </div>
      <div class="col-12 col-sm-6 col-md-3 col-xl-2">
        <div class="form-group d-flex flex-column">
          <label class="mb-0">{{ 'product.expirationDate' | translate }}:</label>
          <select class="form-control" [(ngModel)]="selectedExpirationDate">
            <option *ngFor="let exp of expirationDates" value="{{ exp }}">
              {{ (exp !== 'all' ? (exp | fmtDate: 'dd.MM.yyyy') : exp) | translate }}
            </option>
          </select>
        </div>
      </div>
    </ng-container>
    <div class="col-12 col-sm-6 col-md-3 col-xl-2">
      <form-row-select
        [label]="'createdBy'"
        [(model)]="filterUser"
        [options]="users"
        [optionKeyText]="'email'"
        [icon]="null"
      ></form-row-select>
    </div>
    <div class="col-12 col-sm-6 col-md-3 col-xl-1" *ngIf="selectedOperationType !== 'in'">
      <form-row-select
        [label]="'depot.from'"
        [(model)]="selectedDepotFrom"
        [options]="depots"
        [icon]="null"
      ></form-row-select>
    </div>
    <div class="col-12 col-sm-6 col-md-3 col-xl-1" *ngIf="selectedOperationType !== 'out'">
      <form-row-select
        [label]="'depot.to'"
        [(model)]="selectedDepotTo"
        [options]="depots"
        [icon]="null"
      ></form-row-select>
    </div>
  </div>
</app-filter-form>

<div class="card mb-0">
  <div
    class="card-body p-0"
    [ngClass]="{ h150: !productMoves || (productMoves && productMoves.length === 0 && loading) }"
  >
    <loading-spinner [isLoading]="loading" [classesString]="'pt-6'"></loading-spinner>
    <div
      class="empty-list text-center p-5"
      *ngIf="!productMoves || (productMoves && productMoves.length === 0 && !loading)"
    >
      <i class="far fa-sad-tear" data-cy="empty"></i>
      <div>
        {{ 'no.record.found' | translate }}
      </div>
    </div>
    <div class="table-wrap table_responsive" *ngIf="!loading">
      <table class="table mb-0" *ngIf="productMoves.length > 0">
        <thead>
          <tr>
            <th scope="col" class="cursor-pointer text-nowrap fixed-column-width pl-0" (click)="sortBy('created')">
              {{ 'reports.dateCreated' | translate }}
              <i
                class="fa"
                [ngClass]="{
                  'fa-caret-up': sortProp === 'created' && sortDir === 'asc',
                  'fa-caret-down': sortProp === 'created' && sortDir === 'desc',
                }"
              ></i>
            </th>
            <th class="text-nowrap" scope="col">
              {{ 'number' | translate }}
            </th>
            <th class="text-nowrap" scope="col">
              <span *ngIf="selectedOperationType !== 'in'">
                {{ 'depotFrom' | translate }}
              </span>
              <span *ngIf="selectedOperationType !== 'in' && selectedOperationType !== 'out'">/</span>
              <span *ngIf="selectedOperationType !== 'out'">
                {{ 'depotTo' | translate }}
              </span>
            </th>
            <th class="text-left" scope="col">
              {{ 'checkout' | translate }}
            </th>
            <th class="text-left" scope="col" *ngIf="companyUtil.arePositionsEnabled">
              {{ 'position' | translate }}
            </th>
            <th class="text-nowrap" scope="col" *ngIf="product.enabledBatchExpiration">
              <span>
                {{ 'product.expirationDate' | translate }}
              </span>
              /
              <span>
                {{ 'product.batch' | translate }}
              </span>
            </th>
            <th class="text-center" scope="col">
              {{ 'type' | translate }}
            </th>
            <th scope="col" class="text-center">
              {{ 'operation.amount' | translate }}
            </th>
            <th scope="col">
              {{ 'createdBy' | translate }}
            </th>
            <th class="pr-0 fixed-column-width" scope="col">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let move of productMoves">
            <td class="text-nowrap pl-1">
              {{ move.created ? (move.created | strToDate | date: 'dd.MM.yyyy HH:mm') : '' }}
            </td>
            <td class="text-left text-nowrap">
              {{ move && move.pack && move.pack.number ? move.pack.number : '' }}
            </td>
            <td class="text-nowrap">
              <span *ngIf="selectedOperationType !== 'in' && move.depotFromObj && move.depotFromObj.id > 0">
                <a>
                  {{ move.depotFromObj.name }}
                </a>
              </span>
              <span
                *ngIf="
                  selectedOperationType !== 'in' &&
                  move.depotFromObj &&
                  move.depotFromObj.id > 0 &&
                  selectedOperationType !== 'out' &&
                  move.depotToObj &&
                  move.depotToObj.id > 0
                "
                >/</span
              >
              <span *ngIf="selectedOperationType !== 'out' && move.depotToObj && move.depotToObj.id > 0">
                <a>
                  {{ move.depotToObj.name }}
                </a>
              </span>
            </td>
            <td class="text-left text-nowrap">
              <span *ngIf="move?.pack?.checkout?.name">{{ move.pack.checkout.name }}</span>
            </td>
            <td class="text-left text-nowrap" *ngIf="companyUtil.arePositionsEnabled">
              {{ !!move.position && move.position.length > 2 ? move.position : '' }}
            </td>
            <td class="text-left text-nowrap" *ngIf="product.enabledBatchExpiration">
              <span *ngIf="move.expirationDate && !move.expirationDate.includes('00:00:00')">
                {{ move.expirationDate | fmtDate: 'dd.MM.yyyy HH:mm' }}
              </span>
              <span *ngIf="move.expirationDate && move.expirationDate.includes('00:00:00')">
                {{ move.expirationDate | fmtDate: 'dd.MM.yyyy' }}
              </span>
              <span *ngIf="move.expirationDate && move.batch">/</span>
              <span *ngIf="move.batch">
                {{ move.batch }}
              </span>
            </td>
            <td class="text-nowrap text-center">
              <span class="in-badge" *ngIf="move.pack.type.id === 'in'" title="{{ move.pack.type.id | translate }}">
                <i class="fas fa-plus-square"></i>
              </span>
              <span class="out-badge" *ngIf="move.pack.type.id === 'out'" title="{{ move.pack.type.id | translate }}">
                <i class="fas fa-minus-square"></i>
              </span>
            </td>
            <td class="text-center text-nowrap">
              <strong>
                {{ move.amount === 0 || move.amount === null ? '0' : move.amount.toFixed(2) }}
              </strong>
            </td>
            <td>
              <span class="text-nowrap" *ngIf="move.createdBy && move.createdBy.id > 0">
                <a class="link" [routerLink]="['/user', move.createdBy.id]" [title]="move.createdBy.email">
                  {{
                    move.createdBy.firstName && move.createdBy.firstName.length > 0
                      ? move.createdBy.firstName + ' ' + move.createdBy.lastName
                      : move.createdBy.email
                  }}
                </a>
              </span>
            </td>
            <td class="pr-1">
              <a class="btn-second" [routerLink]="['/product-move-pack', move.pack.id]">
                {{ 'open' | translate }}
                <i class="far fa-chevron-right align-self-center"></i>
              </a>
            </td>
          </tr>
          <tr *ngIf="totalItems > productMoves.length">
            <td colspan="12" class="p-0 border-0 no-hover text-center">
              <app-pagination-btn
                *ngIf="
                  (!this.currentPage || this.currentPage <= this.endPage) && this.totalItems > this.productMoves.length
                "
                (switchPage)="filter($event.currentPage, $event.sortProp, $event.sortDir, $event.concat)"
                [endPage]="endPage"
                [loadingPage]="loading"
                [currentPage]="currentPage"
              >
              </app-pagination-btn>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
